/*
 * Purpose: Compose Access Shell and wire useAccessShell state into layout and forms.
 * Boundary: Composition only; orchestrates state and render props; no styling logic.
 * Invariants:
 * - Accepts optional defaultMode ('login' | 'register').
 * - ASCII only; no Unicode in comments or strings.
 */

// Imports
import { useState, useCallback } from 'react';

import AccessShellLayout from './accessshell/accessshell-layout';
import AuthForm from './authform';

import { useAccessShell } from './accessshell/accessshell-hooks';
import { AgeContext } from './authform';

// Component AccessShell:
// Headless shell that manages tab mode and provides render props for form panels
export default function AccessShell({ services, defaultMode = 'login', referralCode }) {

    // State Management - track active tab using custom hook
    const { mode, onTab } = useAccessShell({ defaultMode });

    // Derived State - handle minor detection and guardian state
    const [isMinor, setIsMinor] = useState(false);
    const [guardianState, setGuardianState] = useState({
        isValid: false,
        idNumber: '',
        firstName: '',
        lastName: '',
        cellNumber: '',
        isValidOTP: false,
        tcAccepted: false,
        age: null
    });

    // Handlers - for age changes (compute isMinor)
    const setAge = useCallback((age) => {
        setIsMinor(age !== null && age < 18);
    }, []);

    // Rendering - delegate all layout and form composition to AccessShellLayout
    return (
        <AccessShellLayout
            mode={mode}
            onTab={onTab}
            services={services}
            isMinor={isMinor}
            guardianState={guardianState} 
            setGuardianState={setGuardianState}
            renderLogin={() => (
                <AuthForm key="login" mode="login" services={services} />
            )}
            renderRegister={() => (
                <AgeContext.Provider value={{ setAge }}>
                    <AuthForm
                        key="register"
                        mode="register"
                        services={services}
                        guardianState={guardianState}
                        referralCode={referralCode}
                    />
                </AgeContext.Provider>
            )}
        />
    );
}